import { useTranslation } from 'react-i18next'

const AboutPersonalInformation = () => {
  const { t } = useTranslation()

  return <>
    <h1>{ t('about.personal_information.title') }</h1>
    <p>
      { t('about.personal_information.intro') }
    </p>
    <p>
      { t('about.personal_information.change_note') }
    </p>
    <p>
      { t('about.personal_information.when_intro') }
    </p>
    <ul>
      <li>{ t('about.personal_information.when_sell') }</li>
      <li>{ t('about.personal_information.when_buy') }</li>
    </ul>
    <p>
      { t('about.personal_information.once') }
    </p>
    <p>
      { t('about.personal_information.bank_name') }
    </p>
    <p>
      { t('about.personal_information.name_change') }
    </p>
  </>
}

export { AboutPersonalInformation }
